"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
var Portal_1 = require("./Portal");
Object.defineProperty(exports, "Portal", { enumerable: true, get: function () { return __importDefault(Portal_1).default; } });
